import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { AuthContextType, LoginCredentials } from '../types/auth.types';
import { authService } from '../services/auth.service';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [token, setTokenState] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Инициализация: проверяем наличие токена при загрузке
  useEffect(() => {
    const initAuth = () => {
      const savedToken = authService.getToken();

      if (savedToken) {
        setTokenState(savedToken);
      }

      setIsLoading(false);
    };

    initAuth();
  }, []);

  // Вход в систему
  const login = async (credentials: LoginCredentials): Promise<void> => {
    const { access_token } = await authService.login(credentials);
    setTokenState(access_token);
  };

  // Выход из системы
  const logout = () => {
    authService.logout();
    setTokenState(null);
  };

  // Установка токена
  const setToken = (newToken: string) => {
    authService.setToken(newToken);
    setTokenState(newToken);
  };

  const value: AuthContextType = {
    user: null, // Не используем данные пользователя
    token,
    isAuthenticated: !!token,
    isLoading,
    login,
    logout,
    setToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
